import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import { BsSliders2Vertical } from 'react-icons/bs'
import Autocomplete from '../../custom/autocomplete'
import ModalCustom from '../../modal-custom'
import { Controller, useForm } from 'react-hook-form'
import LabelCustom from '../../label-custom'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import UseGroups from '../../../hooks/use-groups'
import UseFactionAll from '../../../hooks/use-factions-all'
import UseDepartmentsAll from '../../../hooks/use-departmentsAll'
import UseTeams from '../../../hooks/use-teams'
import UsePositions from '../../../hooks/use-position'
import { BODYEXPAND, SEARCHEXPAND } from '../../../Constants'
import CustomAutocomplete from '../../CustomAutocomplete'
import UseTeamsExpand from '../../../hooks/expand/use-teams-expand'
import UseDepartmentsExpand from '../../../hooks/expand/use-departments-expand'
import UseFactionExpand from '../../../hooks/expand/use-factions-expand'
import UsePositionsExpand from '../../../hooks/expand/use-position-expand'
import UseGroupsExpand from '../../../hooks/expand/use-groups-expand'

function ModalFilterExpand({
  orgId,
  onFilter,
  setOnFilter,
  handleShowFilter,
  handleCloseFilter,
  getOrgList,
  setIsLoading
}) {
  const {
    reset,
    control,
    setValue,
    setError,
    getValues,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const [divisionId, setDivisionId] = useState(0)
  const [factionId, setFactionId] = useState(0)
  const [departmentId, setDepartmentId] = useState(0)
  const [teamId, setTeamId] = useState(0)
  const [positionId, setPositionId] = useState(0)
  const divisions = UseGroupsExpand(orgId, divisionId) //สายงาน
  const factions = UseFactionExpand(orgId, divisionId, factionId)
  const department = UseDepartmentsExpand(
    orgId,
    divisionId,
    factionId,
    departmentId
  ) //แผนก
  const teams = UseTeamsExpand(orgId, divisionId, departmentId, teamId) //ทีม
  const positions = UsePositionsExpand(
    orgId,
    divisionId,
    departmentId,
    teamId,
    positionId
  ) //ตำแน่ง
  const [isSubmit, setIsSubmit] = useState(false)
  const bodyQuery = JSON.parse(localStorage.getItem(BODYEXPAND))
  const searchQuery = JSON.parse(localStorage.getItem(SEARCHEXPAND))
  useEffect(() => {
    const d = bodyQuery
    setValue('divisions', {
      value: d?.divisions?.value,
      label: d?.divisions?.label
    })
    setDivisionId(d?.divisions?.value)

    setValue('department', {
      value: d?.department?.value,
      label: d?.department?.label
    })
    setDepartmentId(d?.department?.value ?? '')

    setValue('faction', { value: d?.faction?.value, label: d?.faction?.label })
    setFactionId(d?.faction?.value)

    setValue('team', { value: d?.team?.value, label: d?.team?.label })
    setTeamId(d?.team?.value ?? '')

    setValue('position', {
      value: d?.position?.value ?? positionId?.value ?? '',
      label: d?.position?.label ?? positionId?.label ?? ''
    })
    setPositionId(d?.position?.value ?? '')
  }, [isSubmit])

  const onSubmit = (d) => {
    setIsLoading(true)
    const body = {
      orgId,
      searchs: searchQuery ?? '',
      division: d?.divisions.data ?? '',
      faction: d?.faction?.data ?? '',
      department: d?.department?.data ?? '',
      team: d?.team?.data ?? '',
      position: d?.position?.data ?? ''
    }
    localStorage.setItem(BODYEXPAND, JSON.stringify(d))
    setValue('divisionId', d?.department?.label)
    setValue('factionId', d?.divisions?.label)
    setValue('departmentId', d?.faction?.label)
    setValue('teamId', d?.team?.label)
    setValue('positionId', d?.position?.label)

    setIsSubmit(true)
    handleCloseFilter()
    getOrgList(body)
    setIsLoading(false)

    setIsSubmit(false)
  }

  return (
    <ModalCustom open={onFilter} onCancel={handleCloseFilter} width={1000}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <h5>Filter</h5>
        <Row>
          <Col xl={4} md={6}>
            <LabelCustom text="Group" />
            <Controller
              name={'divisions'}
              control={control}
              render={({ field: { value = {} } }) => (
                <>
                  <CustomAutocomplete
                    value={value}
                    placeholder=""
                    options={divisions}
                    onChange={(res) => {
                      setError('divisions', res)
                      setValue('divisions', res)

                      setValue('department', {})
                      setValue('team', {})
                      setValue('position', {})
                      setValue('faction', {})

                      setDivisionId(res?.value)
                      setFactionId(0)
                      setDepartmentId(0)
                      setTeamId(0)
                    }}
                    freeSolo={true}
                  />
                  {/* <Autocomplete
                    value={value}
                    options={divisions}
                    // placeholder={bodyQuery?.department?.label}
                    onChange={(res) => {
                      setError('divisions', res)
                      setValue('divisions', res)

                      setValue('department', {})
                      setValue('team', {})
                      setValue('position', {})
                      setValue('faction', {})

                      setDivisionId(res.value)
                      setFactionId(0)
                      setDepartmentId(0)
                      setTeamId(0)
                    }}
                  /> */}
                </>
              )}
            />
          </Col>
          <Col xl={4} md={6}>
            <LabelCustom text="Department" />
            <Controller
              name={'faction'}
              control={control}
              render={({ field: { value = {}, onChange } }) => (
                <CustomAutocomplete
                  disabled={
                    divisionId > 0 ? false : true || !divisionId ? true : false
                  }
                  value={value ?? bodyQuery?.divisions?.label}
                  options={factions}
                  onChange={(res) => {
                    setError('faction', res)
                    setValue('faction', res)

                    setValue('department', {})
                    setValue('team', {})
                    setValue('position', {})

                    setFactionId(res?.value)
                    setDepartmentId('')
                    setTeamId(0)
                  }}
                  freeSolo={true}
                />
                // <Autocomplete
                //   disabled={divisionId > 0 ? false : true}
                //   value={value ?? bodyQuery?.divisions?.label}
                //   options={factions}
                //   onChange={(res) => {
                //     setError('faction', res)
                //     setValue('faction', res)

                //     setValue('department', {})
                //     setValue('team', {})
                //     setValue('position', {})

                //     setFactionId(res.value)
                //     setDepartmentId(0)
                //     setTeamId(0)
                //   }}
                // />
              )}
            />
          </Col>
          <Col xl={4} md={6}>
            <LabelCustom text="Division" />
            <Controller
              name={'department'}
              control={control}
              render={({ field: { value = {} } }) => (
                <CustomAutocomplete
                  value={value ?? bodyQuery?.faction?.label}
                  disabled={factionId > 0 ? false : true}
                  options={department}
                  onChange={(res) => {
                    setDepartmentId(res?.value)
                    setError('department', res)

                    setValue('department', res)
                    setValue('team', {})
                    setValue('position', {})
                    setTeamId('')
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={6} md={6} className="mt-2 mb-2">
            <LabelCustom text="Team" />
            <Controller
              name={'team'}
              control={control}
              render={({ field: { value = {} } }) => (
                <CustomAutocomplete
                  value={value ?? bodyQuery?.team?.label}
                  disabled={departmentId > 0 ? false : true}
                  options={teams}
                  onChange={(res) => {
                    setTeamId(res?.value)
                    setValue('team', res)
                    setError('team', res)

                    setValue('position', {})
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={6} md={6} className="mt-2 mb-2">
            <LabelCustom text="Position" />
            <Controller
              name={'position'}
              control={control}
              render={({ field: { value = {} } }) => (
                <CustomAutocomplete
                  value={value ?? bodyQuery?.position?.label}
                  disabled={teamId > 0 ? false : true}
                  options={positions}
                  onChange={(res) => {
                    setValue('position', res)
                    setError('position', res)
                    // setValue('level_id', res.level_id)
                    // setError('level_id', res.level_id)
                    setPositionId(res)
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <div className="d-flex justify-content-center gap-2 mt-3">
            <Button
              variant="light"
              className="text-primary px-4"
              size="sm"
              onClick={handleCloseFilter}
            >
              Close
            </Button>
            <Button className="px-4" type="submit" size="sm">
              {isSubmit ? 'Submiting...' : 'Submit'}
            </Button>
          </div>
        </Row>
      </Form>
    </ModalCustom>
  )
}

export default ModalFilterExpand
